(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmelan-for-new-user"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // === GTM dataLayer Event Tracking ===
  window.dataLayer = window.dataLayer || [];

  function pushEvent(eventName, ctaLocation) {
    window.dataLayer.push({
      event: 'lp_cta_click',
      cta_location: ctaLocation,
      page_type: 'cosmelan_lp_v2',
      page_path: window.location.pathname
    });
  }

  document.querySelectorAll('[data-event]').forEach(function(el) {
    el.addEventListener('click', function() {
      pushEvent('lp_cta_click', el.getAttribute('data-event'));
    });
  });

  // === Scroll Depth Tracking ===
  var scrollMarks = {25: false, 50: false, 75: false, 100: false};
  window.addEventListener('scroll', function() {
    var scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
    [25, 50, 75, 100].forEach(function(mark) {
      if (scrollPercent >= mark && !scrollMarks[mark]) {
        scrollMarks[mark] = true;
        window.dataLayer.push({
          event: 'scroll_depth',
          depth: mark,
          page_type: 'cosmelan_lp_v2'
        });
      }
    });
  }, { passive: true });

  // === IntersectionObserver — Section View Events ===
  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var sectionId = entry.target.id;
          if (sectionId === 'assessment') {
            window.dataLayer.push({ event: 'assessment_view', page_type: 'cosmelan_lp_v2' });
            sectionObserver.unobserve(entry.target);
          }
        }
      });
    }, { threshold: 0.3 });

    var assessmentSection = document.getElementById('assessment');
    if (assessmentSection) sectionObserver.observe(assessmentSection);

    var guaranteeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          window.dataLayer.push({ event: 'guarantee_view', page_type: 'cosmelan_lp_v2' });
          guaranteeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    var guaranteeSection = document.querySelector('.guarantee');
    if (guaranteeSection) guaranteeObserver.observe(guaranteeSection);
  }

  // === Smooth Scroll for Anchor Links ===
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
